<template>
  <a-layout id="main-wrapper">
    <a-layout>
      <a-layout-header :style="{ background: '#fff', padding: 0 }">
        <a-menu
          style="font-family: 'ZCOOL QingKe HuangYou', cursive; font-size: 1.4em; line-height: 64px;"
          mode="horizontal"
        >
          <a-menu-item>
            <router-link to="/">
              <img
                src="./assets/images/logo.png"
                width="100%"
                alt="fireboundsoft logo"
                class="logo"
              />
            </router-link>
          </a-menu-item>
          <a-menu-item key="games">
            <router-link to="/games">Games</router-link>
          </a-menu-item>
          <a-menu-item key="devlog">
            <router-link to="/devlog/feed">Devlog</router-link>
          </a-menu-item>
          <a-menu-item key="shop">
            <router-link to="/about">About</router-link>
          </a-menu-item>
          <a-menu-item key="admin" v-if="isLogged">
            <router-link to="/admin">Admin</router-link>
          </a-menu-item>
        </a-menu>
      </a-layout-header>

      <a-layout-content :style="{ margin: '0' }">
        <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
          <router-view></router-view>
        </div>
      </a-layout-content>
      <a-layout-footer style="textAlign: center">Firebound Soft ©2019</a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import firebase from "@/configs/firebase-setup";

export default {
  data() {
    return {
      isLogged: false
    };
  },

  mounted() {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        this.isLogged = true;
      }
    });
    this.isLogged = firebase.auth().currentUser != null;
  },
  methods: {
    onCollapse(collapsed, type) {
      console.log(collapsed, type);
    },
    onBreakpoint(broken) {
      console.log(broken);
    }
  }
};
</script>

<style scoped>
#main-wrapper {
  width: 100%;
}
.logo {
  width: 100%;
  max-width: 50px;
}
</style>
